import _Set from 'babel-runtime/core-js/set';
import _typeof from 'babel-runtime/helpers/typeof';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import AiTranslate from '@com/components/ai-translate';
import { mapActions, mapMutations, mapState } from 'vuex';
import { cameraSceneConfigType, gameConfigCategoryResourceType, globalConfigCategoryResourceType, i18nCategoryResourceType, isGlobalCategory, presetOptionCategoryResourceType, presetConfigCategoryResourceType, isPresetConfigParentCategory } from '@/store/creative/common/category';
import { dotNotationToBracketNotation } from '@com/utils/string';
import { changeMaterialByIdAndKey, getMaterialList } from '@/views/creative/utils/model-material-utils';
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category';
import { SPEC_PREFIX_MODEL, SPEC_SEP, SPEC_PREFIX_CONFIG, SPEC_PREFIX_DESC, SPEC_PREFIX_OPTIONS, SPEC_PREFIX_UNIT, SPEC_PS_PREFIX, SPEC_PREFIX_PRESET_OPTIONS, I18nKeyManager } from './i18n-key-utils';

export default {
  props: {
    dialogProps: Object
  },
  components: {
    AiTranslate: AiTranslate
  },
  data: function data() {
    return {
      projectId: 0,
      projectSource: 'portal',
      sourceLanguage: 'zh-cn',
      targetLanguage: 'en',
      projectLanguages: {},
      // 翻译坑位的时候只支持中英文翻译
      languageSourceLists: [{
        code: 'en',
        name: '英文'
      }, {
        code: 'zh-cn',
        name: '中文'
      }]
    };
  },

  computed: _extends({}, mapState({
    category: function category(state) {
      return state.creative.template.templateConfig.category;
    },
    gameConfigResource: function gameConfigResource(state) {
      return state.creative.template.gameConfigResource;
    },
    actions: function actions(state) {
      return state.creative.template.templateConfig.actions;
    },
    gameConfig: function gameConfig(state) {
      return state.creative.template.templateConfig.json_config.gameConfig;
    },
    playConfig: function playConfig(state) {
      return state.creative.template.templateConfig.play_config;
    },
    presetConfig: function presetConfig(state) {
      return state.creative.template.templateConfig.json_config.presetConfig;
    },
    orbitParams: function orbitParams(state) {
      return state.creative.modelEditor.cameraAdaptConfig.orbitParams;
    }
  })),
  methods: _extends({}, mapMutations({
    updateTargetPlayConfig: 'creative/template/updateTargetPlayConfig',
    updateEditorI18nStore: 'creative/template/updateEditorI18nStore',
    updateTemplateActionsEnName: 'creative/template/updateTemplateActionsEnName',
    setOrbitParams: 'creative/modelEditor/setOrbitParams'
  }), mapActions({
    updateTargetCategory: 'creative/template/updateTargetCategory'
  }), {
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.aiTranslate.validate(function (valid) {
        if (valid) {
          var translateData = _this.$refs.aiTranslate.getTranslateData();
          _.each(translateData, function (item, lang) {
            var normalCategoryArray = item.filter(function (v) {
              return !String(v.key).includes(SPEC_PREFIX_CONFIG) && !String(v.key).includes(SPEC_PS_PREFIX) && !String(v.key).includes(SPEC_PREFIX_PRESET_OPTIONS) && !String(v.key).includes(SPEC_PREFIX_MODEL);
            });
            var gameConfigCategoryArray = item.filter(function (v) {
              return String(v.key).includes(SPEC_PREFIX_CONFIG);
            });
            var psEditorConfigArray = item.filter(function (v) {
              return String(v.key).includes(SPEC_PS_PREFIX);
            });
            var presetConfigCategoryArray = item.filter(function (v) {
              return String(v.key).includes(SPEC_PREFIX_PRESET_OPTIONS);
            });
            var modelCategoryArray = item.filter(function (v) {
              return I18nKeyManager.model.has(String(v.key));
            });
            var cameraSceneConfigArray = item.filter(function (v) {
              return I18nKeyManager.camera.has(String(v.key));
            });
            // 自定义埋点
            var actionArray = item.filter(function (v) {
              return String(v.key).includes('action');
            });
            // 挑选出非 gameConfig / ps / presetConfig 的字段, 直接新增到 name_en 到 category
            _.each(normalCategoryArray, function (v, k) {
              _this.updateTargetCategory({
                id: v.key,
                name_en: v.value
              });
            });
            var gameConfigModifyData = {};
            // 如果是嵌套的 gameConfig ，mappingPath 会包含 [items]，需要特殊处理
            var isNestInstance = function isNestInstance(key) {
              return String(key).includes('[items]');
            };
            // 挑选出 gameConfig 的字段, 需要根据前缀区分是 desc 还是 options
            _.each(gameConfigCategoryArray, function (v, k) {
              var key = v.key;
              var value = v.value;
              var keyArray = key.split(SPEC_SEP);
              var categoryId = keyArray[1];
              var suffix = keyArray[2];
              var mappingPath = keyArray[3];
              var gameConfig = _.get(_this.gameConfig, mappingPath.replace('[gameConfig]', ''));
              var specKey = categoryId;
              if (isNestInstance(mappingPath)) {
                specKey = mappingPath;
              }
              // 如果不是嵌套配置，只要通过 categoryId 就可以更新对应的 gameConfig
              // 如果是嵌套配置，需要通过 mappingPath 来更新对应的 gameConfig
              if (!gameConfigModifyData[specKey]) {
                gameConfigModifyData[specKey] = {};
              }
              var modifyData = gameConfigModifyData[specKey];
              // suffix 和 SPEC_PREFIX_CONFIG 相同，说明是 gameConfig 的 name_en 字段
              if (suffix === SPEC_PREFIX_CONFIG) {
                modifyData.name_en = value;
              } else if (suffix === SPEC_PREFIX_DESC) {
                modifyData.desc_en = value;
              } else if (suffix.includes(SPEC_PREFIX_OPTIONS) && gameConfig.options && gameConfig.options.length) {
                modifyData.options = gameConfig.options;
                var optionIndex = Number(suffix.replace(SPEC_PREFIX_OPTIONS, ''));
                if (!modifyData.options_en) {
                  modifyData.options_en = [];
                }
                var gameConfigOption = gameConfig.options[optionIndex];
                if ((typeof gameConfigOption === 'undefined' ? 'undefined' : _typeof(gameConfigOption)) === 'object' && gameConfigOption.text) {
                  modifyData.options_en[optionIndex] = _extends({}, gameConfigOption, {
                    text: value
                  });
                } else {
                  modifyData.options_en[optionIndex] = value;
                }
              } else if (suffix === SPEC_PREFIX_UNIT && gameConfig.unit) {
                modifyData.unit = gameConfig.unit;
                modifyData.unit_en = value;
              }
            });
            _.each(gameConfigModifyData, function (v, k) {
              if (isNestInstance(k)) {
                _this.updateTargetPlayConfig({
                  key: k.replace('[gameConfig]', ''),
                  value: v
                });
              } else {
                _this.updateTargetCategory(_extends({
                  id: k
                }, v));
              }
            });
            // 挑选出 psEditorConfig 的字段, 直接改动 playConfig 里面的值
            _.each(psEditorConfigArray, function (v, k) {
              var key = v.key.replace(SPEC_PS_PREFIX, '');
              var value = v.value;
              _this.updateEditorI18nStore({
                key: key,
                value: value
              });
            });
            // 挑选出 presetConfig 的字段, 直接改动 presetConfig 里面的值
            _.each(presetConfigCategoryArray, function (v, k) {
              var key = v.key.replace(SPEC_PREFIX_PRESET_OPTIONS, '');
              var value = v.value;
              var keyArray = key.split(SPEC_SEP);
              var prefix = keyArray[0];
              var optionIndex = Number(keyArray[1]);
              var presetConfig = _this.presetConfig[prefix];
              if (presetConfig.options_en && presetConfig.options_en.length) {
                if (_typeof(presetConfig.options_en[optionIndex]) === 'object') {
                  presetConfig.options_en[optionIndex].text = value;
                } else {
                  presetConfig.options_en[optionIndex] = value;
                }
              }
            });
            _.each(modelCategoryArray, function (v, k) {
              var _I18nKeyManager$model = I18nKeyManager.model.decode(v.key),
                  categoryId = _I18nKeyManager$model.categoryId,
                  modelKey = _I18nKeyManager$model.modelKey,
                  modelId = _I18nKeyManager$model.modelId;

              var value = v.value;
              var category = useIdToFindCategory({
                category: _this.category,
                categoryId: Number(categoryId)
              });
              changeMaterialByIdAndKey(category, modelId, modelKey + '_en', value);
            });
            // 更新模板actions的值
            _.each(actionArray, function (val) {
              _this.updateTemplateActionsEnName({
                key: val.key,
                value: val.value
              });
            });
            // 更新镜头的值
            _.each(cameraSceneConfigArray, function (v, k) {
              var index = I18nKeyManager.camera.decode(v.key);
              var targetOldData = _.cloneDeep(_this.orbitParams[index]);
              targetOldData.title_en = v.value;
              _this.setOrbitParams(targetOldData);
            });
            // eslint-disable-next-line vue/no-mutating-props
            _this.dialogProps.visible = false;
          });
        }
      });
    },
    setLocalLang: function setLocalLang() {
      this.sourceLanguage = 'zh-cn';
    },
    getGameConfigByPrefix: function getGameConfigByPrefix(prefix) {
      if (this.gameConfig && _.get(this.gameConfig, prefix)) {
        return _.get(this.gameConfig, prefix);
      }

      return {};
    },
    getPlayConfigByMappingPath: function getPlayConfigByMappingPath(mappingPath) {
      if (this.playConfig && this.playConfig.gameConfig && _.get(this.playConfig.gameConfig, mappingPath)) {
        return _.get(this.playConfig.gameConfig, mappingPath);
      }

      return {};
    },

    // 如果是嵌套的 gameConfig ，返回嵌套的内容
    getGameConfigNestInstanceByConfig: function getGameConfigNestInstanceByConfig(gameConfig) {
      var result = function () {
        if (gameConfig.type !== 'array' && gameConfig.type !== 'object' && gameConfig.type !== 'arrayObject') {
          return null;
        }

        // 自定义数组子项
        if (gameConfig.type === 'array' && Array.isArray(gameConfig.items)) {
          return gameConfig.items;
        }

        // 自定义对象子项
        if (gameConfig.type === 'object' && _.isPlainObject(gameConfig.items)) {
          return gameConfig.items;
        }

        // 自定义对象子项 value
        if (gameConfig.type === 'object' && _.isPlainObject(gameConfig.value)) {
          return gameConfig.value;
        }

        // 自定义数组子项
        if (gameConfig.type === 'arrayObject' && Array.isArray(gameConfig.value)) {
          return gameConfig.value;
        }

        // value 为数组，但是没有 items，且 subtype 是 slider 或 input，这种数据不需要渲染子项的标题与描述
        if (Array.isArray(gameConfig.value)) {
          return gameConfig.value.map(function (item) {
            // 嵌套 slider
            if (gameConfig.subtype === 'slider') {
              return {
                value: item,
                min: gameConfig.min,
                max: gameConfig.max,
                type: 'slider',
                unit: gameConfig.unit,
                mw_slider_editable: false
              };
            }

            // 嵌套 input
            if (gameConfig.subtype.indexOf('input') === 0) {
              return {
                value: item,
                type: 'input'
              };
            }

            return null;
          });
        }

        return null;
      }();
      console.log('getGameConfigNestInstanceByConfig 返回:', result, 'gameConfig:', gameConfig);
      return result;
    },
    setCategoryInfo: function setCategoryInfo() {
      var _this2 = this;

      // 只遍历以下类型的分类
      var resourceType = ['normal', i18nCategoryResourceType, gameConfigCategoryResourceType, 'zip', globalConfigCategoryResourceType, cameraSceneConfigType, presetOptionCategoryResourceType, presetConfigCategoryResourceType];
      var cnCategory = [];
      var enCategory = [];
      var parentIndex = 0;
      var recFn = function recFn(category, name, name_en) {
        if (category.sub_category && category.sub_category.length && category.resource_type !== 'group' && category.resource_type !== presetOptionCategoryResourceType && !isPresetConfigParentCategory(category)) {
          parentIndex++;
          category.sub_category.forEach(function (item) {
            recFn(item, category.name, category.name_en);
          });
        } else {
          var categoryId = category.id;
          // 玩法的文案，key 要包含以下内容，以确保可以更新对应的 category 和 gameConfig
          // 1. prefix，
          // 2. categoryId，
          // 3. 唯一标识用于区分这个文案究竟在 gameConfig 的哪个属性下（name/desc/options/unit)
          // 4. gameConfig 的 mappingPath
          var setGameConfigToArray = function setGameConfigToArray(gameConfig, prefixKey) {
            console.log('[调试] setGameConfigToArray 入口', 'gameConfig:', gameConfig, 'prefixKey:', prefixKey, 'mw_mapping_path:', gameConfig.mw_mapping_path);
            var gameConfigName = '动态参数';
            var gameConfigIndex = 1002;
            // 如果含有嵌套的 gameConfig，递归调用
            var nest = _this2.getGameConfigNestInstanceByConfig(gameConfig);
            if (nest) {
              _.each(nest, function (config) {
                console.log('[调试] 递归前 config:', config);
                setGameConfigToArray(config, prefixKey);
                console.log('[调试] 递归后 config:', config);
              });
            }
            var mappingPath = String(gameConfig.mw_mapping_path);
            console.log('[调试] mappingPath:', mappingPath, 'gameConfig:', gameConfig);
            if (mappingPath === 'undefined') {
              console.error('[调试] mappingPath 为 undefined，gameConfig:', gameConfig);
            }
            var playConfig = _this2.getPlayConfigByMappingPath(mappingPath.replace('[gameConfig]', ''));
            // 检查 key 是否重复
            if (!_this2._allKeys) _this2._allKeys = new _Set();
            var keyConfig = '' + prefixKey + SPEC_SEP + categoryId + SPEC_SEP + SPEC_PREFIX_CONFIG + SPEC_SEP + mappingPath;
            if (_this2._allKeys.has(keyConfig)) {
              console.warn('发现重复key: CONFIG', keyConfig, gameConfig, prefixKey, categoryId);
            }
            _this2._allKeys.add(keyConfig);
            cnCategory.push({
              key: keyConfig,
              parent: gameConfigName,
              parentIndex: gameConfigIndex,
              value: playConfig.name || gameConfig.title || gameConfig.desc || category.name
            });
            enCategory.push({
              key: keyConfig,
              parent: gameConfigName,
              parentIndex: gameConfigIndex,
              value: playConfig.name_en || playConfig.name || gameConfig.title_en || gameConfig.title || gameConfig.desc_en || gameConfig.desc || category.name_en || category.name
            });
            var keyDesc = '' + prefixKey + SPEC_SEP + categoryId + SPEC_SEP + SPEC_PREFIX_DESC + SPEC_SEP + mappingPath;
            if (_this2._allKeys.has(keyDesc)) {
              console.warn('发现重复key: DESC', keyDesc, gameConfig, prefixKey, categoryId);
            }
            _this2._allKeys.add(keyDesc);
            cnCategory.push({
              key: keyDesc,
              parent: gameConfigName,
              parentIndex: gameConfigIndex,
              value: playConfig.desc || gameConfig.desc || gameConfig.title || category.name
            });
            enCategory.push({
              key: keyDesc,
              parent: gameConfigName,
              parentIndex: gameConfigIndex,
              value: playConfig.desc_en || playConfig.desc || gameConfig.desc_en || gameConfig.desc || gameConfig.title_en || gameConfig.title || category.name_en || category.name
            });
            // 如果含有 gameConfig 的 options，也需要把 options 带过去
            if (gameConfig.options && gameConfig.options.length) {
              gameConfig.options.forEach(function (item, index) {
                var optionsText = (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item.text ? item.text : item;
                var keyOptions = '' + prefixKey + SPEC_SEP + categoryId + SPEC_SEP + SPEC_PREFIX_OPTIONS + index + SPEC_SEP + mappingPath;
                if (_this2._allKeys.has(keyOptions)) {
                  console.warn('发现重复key: OPTIONS', keyOptions, gameConfig, prefixKey, categoryId);
                }
                _this2._allKeys.add(keyOptions);
                cnCategory.push({
                  key: keyOptions,
                  parent: gameConfigName,
                  parentIndex: gameConfigIndex,
                  value: optionsText
                });
                if (playConfig.options_en && playConfig.options_en.length) {
                  optionsText = _typeof(playConfig.options_en[index]) === 'object' && playConfig.options_en[index].text ? playConfig.options_en[index].text : playConfig.options_en[index];
                }
                enCategory.push({
                  key: keyOptions,
                  parent: gameConfigName,
                  parentIndex: gameConfigIndex,
                  value: optionsText
                });
              });
            }
            // 如果含有 unit 单位，也需要把单位带过去
            if (gameConfig.unit) {
              var keyUnit = '' + prefixKey + SPEC_SEP + categoryId + SPEC_SEP + SPEC_PREFIX_UNIT + SPEC_SEP + mappingPath;
              if (_this2._allKeys.has(keyUnit)) {
                console.warn('发现重复key: UNIT', keyUnit, gameConfig, prefixKey, categoryId);
              }
              _this2._allKeys.add(keyUnit);
              cnCategory.push({
                key: keyUnit,
                parent: gameConfigName,
                parentIndex: gameConfigIndex,
                value: gameConfig.unit
              });
              enCategory.push({
                key: keyUnit,
                parent: gameConfigName,
                parentIndex: gameConfigIndex,
                value: playConfig.unit_en || gameConfig.unit
              });
            }
          };
          var setCategoryToArray = function setCategoryToArray() {
            console.log('setCategoryToArray', { category: category, name: name, name_en: name_en });
            // 如果是玩法的坑位，需要把玩法的 desc 也加进去
            // 如果玩法里面含有嵌套的 gameConfig，需要把嵌套的 gameConfig 也加进去
            if (gameConfigCategoryResourceType === category.resource_type) {
              // 如果是全局的玩法类型，不需要加入到翻译中，因为自带翻译
              if (isGlobalCategory(category.id)) return;
              var gameConfig = _this2.getGameConfigByPrefix(category.prefix);
              var prefixKey = dotNotationToBracketNotation(category.prefix);
              setGameConfigToArray(gameConfig, prefixKey);
            } else if (cameraSceneConfigType === category.resource_type) {
              if (_this2.orbitParams && _this2.orbitParams.length) {
                _this2.orbitParams.forEach(function (orbitParam, index) {
                  cnCategory.push({
                    key: I18nKeyManager.camera.encode(index),
                    parent: name,
                    parentIndex: parentIndex,
                    value: orbitParam.title
                  });
                  enCategory.push({
                    key: I18nKeyManager.camera.encode(index),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: orbitParam.title_en || orbitParam.title
                  });
                });
              }
            } else {
              cnCategory.push({
                key: category.id,
                parent: name,
                parentIndex: parentIndex,
                value: category.name
              });
              enCategory.push({
                key: category.id,
                parent: name_en,
                parentIndex: parentIndex,
                value: category.name_en || category.name
              });
              if (getMaterialList(category)) {
                var materialList = getMaterialList(category);
                materialList.forEach(function (item) {
                  cnCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'name'),
                    parent: name,
                    parentIndex: parentIndex,
                    value: item.name
                  });
                  enCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'name'),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: item.name_en
                  });
                  cnCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_one_name'),
                    parent: name,
                    parentIndex: parentIndex,
                    value: item.part_one_name
                  });
                  enCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_one_name'),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: item.part_one_name_en
                  });
                  cnCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_two_name'),
                    parent: name,
                    parentIndex: parentIndex,
                    value: item.part_two_name
                  });
                  enCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_two_name'),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: item.part_two_name_en
                  });
                  cnCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_three_name'),
                    parent: name,
                    parentIndex: parentIndex,
                    value: item.part_three_name
                  });
                  enCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_three_name'),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: item.part_three_name_en
                  });
                  cnCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_four_name'),
                    parent: name,
                    parentIndex: parentIndex,
                    value: item.part_four_name
                  });
                  enCategory.push({
                    key: I18nKeyManager.model.encode(category.id, item.id, 'part_four_name'),
                    parent: name_en,
                    parentIndex: parentIndex,
                    value: item.part_four_name_en
                  });
                });
              }
            }
          };
          if ((category.resource_type === 'group' || category.resource_type === presetOptionCategoryResourceType) && category.sub_category && category.sub_category.length) {
            setCategoryToArray();
            category.sub_category.forEach(function (item) {
              recFn(item, name, name_en);
            });
          } else if (resourceType.includes(category.resource_type)) {
            setCategoryToArray();
          }
        }
      };
      console.time('setCategoryToArray');
      _.each(this.category, function (item) {
        recFn(item, '', '');
      });
      // 如果包含 editorConfig，需要把 editorConfig 也加进去
      if (this.playConfig.editorConfig && this.playConfig.editorConfig.i18nStore && Array.isArray(this.playConfig.editorConfig.i18nStore) && this.playConfig.editorConfig.i18nStore.length) {
        var i18nStore = this.playConfig.editorConfig.i18nStore;
        i18nStore.forEach(function (item) {
          if (item.type === 'customEvent') {
            cnCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '自定义事件',
              parentIndex: 1000,
              value: item.label
            });
            enCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '自定义事件',
              parentIndex: 1000,
              value: item.labelEn
            });
          }
          if (item.type === 'tween') {
            cnCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '动画',
              parentIndex: 1001,
              value: item.label
            });
            enCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '动画',
              parentIndex: 1001,
              value: item.labelEn
            });
          }
          if (item.type === 'drawLine') {
            cnCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '配对名称',
              parentIndex: 1002,
              value: item.label
            });
            enCategory.push({
              key: '' + SPEC_PS_PREFIX + item.id,
              parent: '配对名称',
              parentIndex: 1002,
              value: item.labelEn
            });
          }
        });
      }
      if (this.actions) {
        for (var key in this.actions) {
          console.log(this.actions[key], '自定义埋点');
          cnCategory.push({
            key: key,
            parent: '自定义埋点',
            parentIndex: 1003,
            value: this.actions[key]['zh-cn']
          });
          enCategory.push({
            key: key,
            parent: '自定义埋点',
            parentIndex: 1003,
            value: this.actions[key]['en']
          });
        }
      }
      this.projectLanguages = {
        en: enCategory,
        'zh-cn': cnCategory
      };
      console.timeEnd('setCategoryToArray');
      console.log('最终projectLanguages:', this.projectLanguages);
    },
    resetDialogData: function resetDialogData() {
      var _this3 = this;

      this.setLocalLang();
      this.setCategoryInfo();
      this.$nextTick(function () {
        if (_this3.$refs.aiTranslate && _this3.$refs.aiTranslate.resetData) {
          _this3.$refs.aiTranslate.resetData();
        }
      });
    }
  }),
  watch: {
    dialogProps: {
      handler: function handler(val) {
        if (val.visible) {
          this.resetDialogData();
        }
      },

      deep: true
    }
  },
  mounted: function mounted() {}
};